import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  // App is now committed to LIGHT mode (per CARTIEAI brand direction Feb 2026).
  // We ignore any previously saved 'dark' value and force light. This ensures
  // Tailwind `dark:*` variants stay OFF so mega-menus, cards, etc. render
  // with their light-mode classes (white bg, dark text) and not the
  // accidentally-saved dark-mode variants.
  const [theme] = useState('light');

  useEffect(() => {
    localStorage.setItem('theme', 'light');
    document.documentElement.classList.remove('dark');
  }, []);

  // Kept for API compatibility — calling setTheme/toggleTheme is a no-op.
  const setTheme = () => {};
  const toggleTheme = () => {};

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, isDark: false }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
